import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Stack,
} from "@mui/material";
import { useDialog } from "../../../../../../utils/hooks/use-dialog";

import type { FC, ReactNode } from "react";

interface Props {
  text: string;
  title: string;
  description?: ReactNode;
  analyticsId: string;
  closeAnalyticsId: string;
  children: ReactNode;
}

export const PreviewDialogLink: FC<Props> = ({
  text,
  title,
  description,
  analyticsId,
  closeAnalyticsId,
  children,
}) => {
  const dialog = useDialog();

  return (
    <>
      <Link
        component="button"
        type="button"
        color="primary"
        underline="hover"
        variant="inherit"
        onClick={() => dialog.handleOpen()}
        data-analytics-id={analyticsId}
        sx={{ display: "inline", verticalAlign: "baseline", textAlign: "left" }}
      >
        {text}
      </Link>
      <Dialog open={dialog.open} onClose={dialog.handleClose} fullWidth maxWidth="md">
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            {description}
            {children}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={dialog.handleClose}
            data-analytics-id={closeAnalyticsId}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
